module.exports = __webpack_public_path__ + "static/media/angle-down.22d441f4.svg";